function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { useState, useEffect } from 'react';
import { Alert as AlertComponent } from 'reactstrap';
import Icon from "./Icon";

var noop = function noop() {
  return undefined;
};

var ICON_MAP = {
  warning: 'exclamation-circle',
  success: 'check',
  info: 'info-circle',
  danger: 'ban'
};
/**
 * Extension to Bootstrap [Alert](https://getbootstrap.com/docs/4.3/components/alert/)
 * adding icon support and onToggle callback when dismissed.
 */

var Alert = function Alert(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'warning' : _ref$color,
      children = _ref.children,
      className = _ref.className,
      _ref$dismissible = _ref.dismissible,
      dismissible = _ref$dismissible === void 0 ? false : _ref$dismissible,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? false : _ref$icon,
      _ref$onToggle = _ref.onToggle,
      onToggle = _ref$onToggle === void 0 ? noop : _ref$onToggle,
      props = _objectWithoutProperties(_ref, ["color", "children", "className", "dismissible", "icon", "onToggle"]);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  useEffect(function () {
    setVisible(true);
  }, [color, children, className, dismissible, icon, onToggle]);

  var toggle = function toggle() {
    setVisible(!visible);
    onToggle(!visible);
  };

  return (
    /*#__PURE__*/
    React.createElement(AlertComponent, _extends({
      color: color,
      isOpen: visible,
      toggle: dismissible ? toggle : undefined,
      className: className
    }, props),
    /*#__PURE__*/
    React.createElement("div", {
      className: "d-flex align-items-start"
    }, icon ?
    /*#__PURE__*/
    React.createElement(Icon, {
      name: ICON_MAP[color],
      size: "lg",
      className: "mr-3 mt-1"
    }) : null, icon ?
    /*#__PURE__*/
    React.createElement("div", {
      className: "w-100",
      style: {
        overflow: 'hidden'
      }
    }, children) :
    /*#__PURE__*/
    React.createElement("div", {
      className: "w-100"
    }, children)))
  );
};

Alert.displayName = "Alert";
Alert.displayName = 'Alert';
export default Alert;